import React, { Fragment, Suspense, lazy } from "react";
import { MuiThemeProvider, CssBaseline } from "@material-ui/core";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import theme from "./theme";
import GlobalStyles from "./GlobalStyles";
import * as serviceWorker from "./serviceWorker";
import Pace from "./shared/components/Pace";
import { AppDataProvider } from "./shared/context/store"
import { gainit, gauser, ga } from "./shared/utils/ga"

const LoggedOutComponent = lazy(() => import("./logged_out/components/Main"));

//--------------------------------------------------
// Goolge analytics init
//--------------------------------------------------
gainit();

//--------------------------------------------------
// FIXME: testing values - to be removed!!
//--------------------------------------------------
gauser('gp-1');
ga('general','load-top-page');


function App() {
  return (
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <AppDataProvider>
          <CssBaseline />
          <GlobalStyles />
          <Pace color={theme.palette.primary.light} />
          <Suspense fallback={<Fragment />}>
            <Switch>
              <Route>
                <LoggedOutComponent />
              </Route>
            </Switch>
          </Suspense>
        </AppDataProvider>
      </MuiThemeProvider>
    </BrowserRouter>
  );
}

serviceWorker.register();

export default App;
